import { useState } from 'react'
import { OrderByDirection, PaginationResponse } from '../swagger'
import { DEFAULT_PAGE_SIZE } from '../utils/constants'

interface UsePaginationResult {
  pagination: PaginationResponse
  setPage: (newPage: number) => void
  setPageSize: (newSize: number) => void
  setOrderBy: (orderBy: PaginationResponse['orderBy']) => void
  setTotalCount: (count: number) => void
}

export const usePagination = ({
  initialOrderBy,
}: {
  initialOrderBy?: PaginationResponse['orderBy']
} = {}): UsePaginationResult => {
  const [pagination, setPagination] = useState<PaginationResponse>({
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    totalCount: 0,
    orderBy: initialOrderBy ?? [{ begunAt: OrderByDirection.Asc }],
  })

  const setPage = (newPage: number) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }))
  }

  const setPageSize = (newSize: number) => {
    setPagination((prev) => ({
      ...prev,
      pageSize: newSize,
    }))
  }

  const setOrderBy = (orderBy: PaginationResponse['orderBy']) => {
    setPagination((prev) => ({
      ...prev,
      orderBy,
      page: 1,
    }))
  }

  const setTotalCount = (count: number) => {
    setPagination((prev) => ({
      ...prev,
      totalCount: count,
    }))
  }

  return {
    pagination,
    setPage,
    setPageSize,
    setOrderBy,
    setTotalCount,
  }
}
